/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AvailabilityImportRouteImport } from './routes/availability-import'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuppliersIndexRouteImport } from './routes/suppliers/index'
import { Route as ReservationsIndexRouteImport } from './routes/reservations/index'
import { Route as OffersIndexRouteImport } from './routes/offers/index'
import { Route as MediaUnitsIndexRouteImport } from './routes/media-units/index'
import { Route as MapIndexRouteImport } from './routes/map/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as OffersNewRouteImport } from './routes/offers/new'
import { Route as OffersOfferIdRouteImport } from './routes/offers/$offerId'
import { Route as MediaImportRouteImport } from './routes/media/import'
import { Route as MediaUnitsIdRouteImport } from './routes/media-units/$id'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminPermissionsRouteImport } from './routes/admin/permissions'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin/feature-flags'
import { Route as OffersOfferIdIndexRouteImport } from './routes/offers/$offerId/index'
import { Route as MediaUnitsTrashIndexRouteImport } from './routes/media-units/trash/index'
import { Route as MediaUnitsAddIndexRouteImport } from './routes/media-units/add/index'
import { Route as MediaUnitsIdIndexRouteImport } from './routes/media-units/$id/index'
import { Route as AdminPoisIndexRouteImport } from './routes/admin/pois/index'
import { Route as PublicOffersTokenRouteImport } from './routes/public/offers/$token'
import { Route as OffersOfferIdClientRouteImport } from './routes/offers/$offerId.client'
import { Route as AdminDictionariesTagsRouteImport } from './routes/admin/dictionaries/tags'
import { Route as AdminDictionariesFormatsRouteImport } from './routes/admin/dictionaries/formats'
import { Route as AdminDictionariesFormatGroupsRouteImport } from './routes/admin/dictionaries/format-groups'
import { Route as PublicOffersTokenIndexRouteImport } from './routes/public/offers/$token.index'
import { Route as MediaUnitsIdEditIndexRouteImport } from './routes/media-units/$id/edit/index'
import { Route as OffersOfferIdVersionsVersionIdRouteImport } from './routes/offers/$offerId.versions.$versionId'
import { Route as OffersOfferIdUnitsUnitIdRouteImport } from './routes/offers/$offerId.units.$unitId'
import { Route as PublicOffersTokenUnitsUnitIdRouteImport } from './routes/public/offers/$token.units.$unitId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityImportRoute = AvailabilityImportRouteImport.update({
  id: '/availability-import',
  path: '/availability-import',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIndexRoute = SuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservationsIndexRoute = ReservationsIndexRouteImport.update({
  id: '/reservations/',
  path: '/reservations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersIndexRoute = OffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaUnitsIndexRoute = MediaUnitsIndexRouteImport.update({
  id: '/media-units/',
  path: '/media-units/',
  getParentRoute: () => rootRouteImport,
} as any)
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/map/',
  path: '/map/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersNewRoute = OffersNewRouteImport.update({
  id: '/offers/new',
  path: '/offers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersOfferIdRoute = OffersOfferIdRouteImport.update({
  id: '/offers/$offerId',
  path: '/offers/$offerId',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaImportRoute = MediaImportRouteImport.update({
  id: '/media/import',
  path: '/media/import',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaUnitsIdRoute = MediaUnitsIdRouteImport.update({
  id: '/media-units/$id',
  path: '/media-units/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
  id: '/admin/permissions',
  path: '/admin/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/admin/feature-flags',
  path: '/admin/feature-flags',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersOfferIdIndexRoute = OffersOfferIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OffersOfferIdRoute,
} as any)
const MediaUnitsTrashIndexRoute = MediaUnitsTrashIndexRouteImport.update({
  id: '/media-units/trash/',
  path: '/media-units/trash/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaUnitsAddIndexRoute = MediaUnitsAddIndexRouteImport.update({
  id: '/media-units/add/',
  path: '/media-units/add/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaUnitsIdIndexRoute = MediaUnitsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MediaUnitsIdRoute,
} as any)
const AdminPoisIndexRoute = AdminPoisIndexRouteImport.update({
  id: '/admin/pois/',
  path: '/admin/pois/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicOffersTokenRoute = PublicOffersTokenRouteImport.update({
  id: '/public/offers/$token',
  path: '/public/offers/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersOfferIdClientRoute = OffersOfferIdClientRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => OffersOfferIdRoute,
} as any)
const AdminDictionariesTagsRoute = AdminDictionariesTagsRouteImport.update({
  id: '/admin/dictionaries/tags',
  path: '/admin/dictionaries/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDictionariesFormatsRoute =
  AdminDictionariesFormatsRouteImport.update({
    id: '/admin/dictionaries/formats',
    path: '/admin/dictionaries/formats',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminDictionariesFormatGroupsRoute =
  AdminDictionariesFormatGroupsRouteImport.update({
    id: '/admin/dictionaries/format-groups',
    path: '/admin/dictionaries/format-groups',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicOffersTokenIndexRoute = PublicOffersTokenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicOffersTokenRoute,
} as any)
const MediaUnitsIdEditIndexRoute = MediaUnitsIdEditIndexRouteImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => MediaUnitsIdRoute,
} as any)
const OffersOfferIdVersionsVersionIdRoute =
  OffersOfferIdVersionsVersionIdRouteImport.update({
    id: '/versions/$versionId',
    path: '/versions/$versionId',
    getParentRoute: () => OffersOfferIdRoute,
  } as any)
const OffersOfferIdUnitsUnitIdRoute =
  OffersOfferIdUnitsUnitIdRouteImport.update({
    id: '/units/$unitId',
    path: '/units/$unitId',
    getParentRoute: () => OffersOfferIdRoute,
  } as any)
const PublicOffersTokenUnitsUnitIdRoute =
  PublicOffersTokenUnitsUnitIdRouteImport.update({
    id: '/units/$unitId',
    path: '/units/$unitId',
    getParentRoute: () => PublicOffersTokenRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/availability-import': typeof AvailabilityImportRoute
  '/login': typeof LoginRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/media-units/$id': typeof MediaUnitsIdRouteWithChildren
  '/media/import': typeof MediaImportRoute
  '/offers/$offerId': typeof OffersOfferIdRouteWithChildren
  '/offers/new': typeof OffersNewRoute
  '/admin/': typeof AdminIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/map/': typeof MapIndexRoute
  '/media-units/': typeof MediaUnitsIndexRoute
  '/offers/': typeof OffersIndexRoute
  '/reservations/': typeof ReservationsIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/admin/dictionaries/format-groups': typeof AdminDictionariesFormatGroupsRoute
  '/admin/dictionaries/formats': typeof AdminDictionariesFormatsRoute
  '/admin/dictionaries/tags': typeof AdminDictionariesTagsRoute
  '/offers/$offerId/client': typeof OffersOfferIdClientRoute
  '/public/offers/$token': typeof PublicOffersTokenRouteWithChildren
  '/admin/pois/': typeof AdminPoisIndexRoute
  '/media-units/$id/': typeof MediaUnitsIdIndexRoute
  '/media-units/add/': typeof MediaUnitsAddIndexRoute
  '/media-units/trash/': typeof MediaUnitsTrashIndexRoute
  '/offers/$offerId/': typeof OffersOfferIdIndexRoute
  '/offers/$offerId/units/$unitId': typeof OffersOfferIdUnitsUnitIdRoute
  '/offers/$offerId/versions/$versionId': typeof OffersOfferIdVersionsVersionIdRoute
  '/media-units/$id/edit/': typeof MediaUnitsIdEditIndexRoute
  '/public/offers/$token/': typeof PublicOffersTokenIndexRoute
  '/public/offers/$token/units/$unitId': typeof PublicOffersTokenUnitsUnitIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/availability-import': typeof AvailabilityImportRoute
  '/login': typeof LoginRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/media/import': typeof MediaImportRoute
  '/offers/new': typeof OffersNewRoute
  '/admin': typeof AdminIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/map': typeof MapIndexRoute
  '/media-units': typeof MediaUnitsIndexRoute
  '/offers': typeof OffersIndexRoute
  '/reservations': typeof ReservationsIndexRoute
  '/suppliers': typeof SuppliersIndexRoute
  '/admin/dictionaries/format-groups': typeof AdminDictionariesFormatGroupsRoute
  '/admin/dictionaries/formats': typeof AdminDictionariesFormatsRoute
  '/admin/dictionaries/tags': typeof AdminDictionariesTagsRoute
  '/offers/$offerId/client': typeof OffersOfferIdClientRoute
  '/admin/pois': typeof AdminPoisIndexRoute
  '/media-units/$id': typeof MediaUnitsIdIndexRoute
  '/media-units/add': typeof MediaUnitsAddIndexRoute
  '/media-units/trash': typeof MediaUnitsTrashIndexRoute
  '/offers/$offerId': typeof OffersOfferIdIndexRoute
  '/offers/$offerId/units/$unitId': typeof OffersOfferIdUnitsUnitIdRoute
  '/offers/$offerId/versions/$versionId': typeof OffersOfferIdVersionsVersionIdRoute
  '/media-units/$id/edit': typeof MediaUnitsIdEditIndexRoute
  '/public/offers/$token': typeof PublicOffersTokenIndexRoute
  '/public/offers/$token/units/$unitId': typeof PublicOffersTokenUnitsUnitIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/availability-import': typeof AvailabilityImportRoute
  '/login': typeof LoginRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/media-units/$id': typeof MediaUnitsIdRouteWithChildren
  '/media/import': typeof MediaImportRoute
  '/offers/$offerId': typeof OffersOfferIdRouteWithChildren
  '/offers/new': typeof OffersNewRoute
  '/admin/': typeof AdminIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/map/': typeof MapIndexRoute
  '/media-units/': typeof MediaUnitsIndexRoute
  '/offers/': typeof OffersIndexRoute
  '/reservations/': typeof ReservationsIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/admin/dictionaries/format-groups': typeof AdminDictionariesFormatGroupsRoute
  '/admin/dictionaries/formats': typeof AdminDictionariesFormatsRoute
  '/admin/dictionaries/tags': typeof AdminDictionariesTagsRoute
  '/offers/$offerId/client': typeof OffersOfferIdClientRoute
  '/public/offers/$token': typeof PublicOffersTokenRouteWithChildren
  '/admin/pois/': typeof AdminPoisIndexRoute
  '/media-units/$id/': typeof MediaUnitsIdIndexRoute
  '/media-units/add/': typeof MediaUnitsAddIndexRoute
  '/media-units/trash/': typeof MediaUnitsTrashIndexRoute
  '/offers/$offerId/': typeof OffersOfferIdIndexRoute
  '/offers/$offerId/units/$unitId': typeof OffersOfferIdUnitsUnitIdRoute
  '/offers/$offerId/versions/$versionId': typeof OffersOfferIdVersionsVersionIdRoute
  '/media-units/$id/edit/': typeof MediaUnitsIdEditIndexRoute
  '/public/offers/$token/': typeof PublicOffersTokenIndexRoute
  '/public/offers/$token/units/$unitId': typeof PublicOffersTokenUnitsUnitIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/availability-import'
    | '/login'
    | '/admin/feature-flags'
    | '/admin/permissions'
    | '/admin/roles'
    | '/admin/users'
    | '/media-units/$id'
    | '/media/import'
    | '/offers/$offerId'
    | '/offers/new'
    | '/admin/'
    | '/clients/'
    | '/map/'
    | '/media-units/'
    | '/offers/'
    | '/reservations/'
    | '/suppliers/'
    | '/admin/dictionaries/format-groups'
    | '/admin/dictionaries/formats'
    | '/admin/dictionaries/tags'
    | '/offers/$offerId/client'
    | '/public/offers/$token'
    | '/admin/pois/'
    | '/media-units/$id/'
    | '/media-units/add/'
    | '/media-units/trash/'
    | '/offers/$offerId/'
    | '/offers/$offerId/units/$unitId'
    | '/offers/$offerId/versions/$versionId'
    | '/media-units/$id/edit/'
    | '/public/offers/$token/'
    | '/public/offers/$token/units/$unitId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/availability-import'
    | '/login'
    | '/admin/feature-flags'
    | '/admin/permissions'
    | '/admin/roles'
    | '/admin/users'
    | '/media/import'
    | '/offers/new'
    | '/admin'
    | '/clients'
    | '/map'
    | '/media-units'
    | '/offers'
    | '/reservations'
    | '/suppliers'
    | '/admin/dictionaries/format-groups'
    | '/admin/dictionaries/formats'
    | '/admin/dictionaries/tags'
    | '/offers/$offerId/client'
    | '/admin/pois'
    | '/media-units/$id'
    | '/media-units/add'
    | '/media-units/trash'
    | '/offers/$offerId'
    | '/offers/$offerId/units/$unitId'
    | '/offers/$offerId/versions/$versionId'
    | '/media-units/$id/edit'
    | '/public/offers/$token'
    | '/public/offers/$token/units/$unitId'
  id:
    | '__root__'
    | '/'
    | '/availability-import'
    | '/login'
    | '/admin/feature-flags'
    | '/admin/permissions'
    | '/admin/roles'
    | '/admin/users'
    | '/media-units/$id'
    | '/media/import'
    | '/offers/$offerId'
    | '/offers/new'
    | '/admin/'
    | '/clients/'
    | '/map/'
    | '/media-units/'
    | '/offers/'
    | '/reservations/'
    | '/suppliers/'
    | '/admin/dictionaries/format-groups'
    | '/admin/dictionaries/formats'
    | '/admin/dictionaries/tags'
    | '/offers/$offerId/client'
    | '/public/offers/$token'
    | '/admin/pois/'
    | '/media-units/$id/'
    | '/media-units/add/'
    | '/media-units/trash/'
    | '/offers/$offerId/'
    | '/offers/$offerId/units/$unitId'
    | '/offers/$offerId/versions/$versionId'
    | '/media-units/$id/edit/'
    | '/public/offers/$token/'
    | '/public/offers/$token/units/$unitId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AvailabilityImportRoute: typeof AvailabilityImportRoute
  LoginRoute: typeof LoginRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminPermissionsRoute: typeof AdminPermissionsRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  MediaUnitsIdRoute: typeof MediaUnitsIdRouteWithChildren
  MediaImportRoute: typeof MediaImportRoute
  OffersOfferIdRoute: typeof OffersOfferIdRouteWithChildren
  OffersNewRoute: typeof OffersNewRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  MapIndexRoute: typeof MapIndexRoute
  MediaUnitsIndexRoute: typeof MediaUnitsIndexRoute
  OffersIndexRoute: typeof OffersIndexRoute
  ReservationsIndexRoute: typeof ReservationsIndexRoute
  SuppliersIndexRoute: typeof SuppliersIndexRoute
  AdminDictionariesFormatGroupsRoute: typeof AdminDictionariesFormatGroupsRoute
  AdminDictionariesFormatsRoute: typeof AdminDictionariesFormatsRoute
  AdminDictionariesTagsRoute: typeof AdminDictionariesTagsRoute
  PublicOffersTokenRoute: typeof PublicOffersTokenRouteWithChildren
  AdminPoisIndexRoute: typeof AdminPoisIndexRoute
  MediaUnitsAddIndexRoute: typeof MediaUnitsAddIndexRoute
  MediaUnitsTrashIndexRoute: typeof MediaUnitsTrashIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-import': {
      id: '/availability-import'
      path: '/availability-import'
      fullPath: '/availability-import'
      preLoaderRoute: typeof AvailabilityImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/': {
      id: '/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof SuppliersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservations/': {
      id: '/reservations/'
      path: '/reservations'
      fullPath: '/reservations/'
      preLoaderRoute: typeof ReservationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/': {
      id: '/offers/'
      path: '/offers'
      fullPath: '/offers/'
      preLoaderRoute: typeof OffersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-units/': {
      id: '/media-units/'
      path: '/media-units'
      fullPath: '/media-units/'
      preLoaderRoute: typeof MediaUnitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map/': {
      id: '/map/'
      path: '/map'
      fullPath: '/map/'
      preLoaderRoute: typeof MapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/new': {
      id: '/offers/new'
      path: '/offers/new'
      fullPath: '/offers/new'
      preLoaderRoute: typeof OffersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/$offerId': {
      id: '/offers/$offerId'
      path: '/offers/$offerId'
      fullPath: '/offers/$offerId'
      preLoaderRoute: typeof OffersOfferIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/import': {
      id: '/media/import'
      path: '/media/import'
      fullPath: '/media/import'
      preLoaderRoute: typeof MediaImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-units/$id': {
      id: '/media-units/$id'
      path: '/media-units/$id'
      fullPath: '/media-units/$id'
      preLoaderRoute: typeof MediaUnitsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/permissions': {
      id: '/admin/permissions'
      path: '/admin/permissions'
      fullPath: '/admin/permissions'
      preLoaderRoute: typeof AdminPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/admin/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/$offerId/': {
      id: '/offers/$offerId/'
      path: '/'
      fullPath: '/offers/$offerId/'
      preLoaderRoute: typeof OffersOfferIdIndexRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/media-units/trash/': {
      id: '/media-units/trash/'
      path: '/media-units/trash'
      fullPath: '/media-units/trash/'
      preLoaderRoute: typeof MediaUnitsTrashIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-units/add/': {
      id: '/media-units/add/'
      path: '/media-units/add'
      fullPath: '/media-units/add/'
      preLoaderRoute: typeof MediaUnitsAddIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-units/$id/': {
      id: '/media-units/$id/'
      path: '/'
      fullPath: '/media-units/$id/'
      preLoaderRoute: typeof MediaUnitsIdIndexRouteImport
      parentRoute: typeof MediaUnitsIdRoute
    }
    '/admin/pois/': {
      id: '/admin/pois/'
      path: '/admin/pois'
      fullPath: '/admin/pois/'
      preLoaderRoute: typeof AdminPoisIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/offers/$token': {
      id: '/public/offers/$token'
      path: '/public/offers/$token'
      fullPath: '/public/offers/$token'
      preLoaderRoute: typeof PublicOffersTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers/$offerId/client': {
      id: '/offers/$offerId/client'
      path: '/client'
      fullPath: '/offers/$offerId/client'
      preLoaderRoute: typeof OffersOfferIdClientRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/admin/dictionaries/tags': {
      id: '/admin/dictionaries/tags'
      path: '/admin/dictionaries/tags'
      fullPath: '/admin/dictionaries/tags'
      preLoaderRoute: typeof AdminDictionariesTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dictionaries/formats': {
      id: '/admin/dictionaries/formats'
      path: '/admin/dictionaries/formats'
      fullPath: '/admin/dictionaries/formats'
      preLoaderRoute: typeof AdminDictionariesFormatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dictionaries/format-groups': {
      id: '/admin/dictionaries/format-groups'
      path: '/admin/dictionaries/format-groups'
      fullPath: '/admin/dictionaries/format-groups'
      preLoaderRoute: typeof AdminDictionariesFormatGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/offers/$token/': {
      id: '/public/offers/$token/'
      path: '/'
      fullPath: '/public/offers/$token/'
      preLoaderRoute: typeof PublicOffersTokenIndexRouteImport
      parentRoute: typeof PublicOffersTokenRoute
    }
    '/media-units/$id/edit/': {
      id: '/media-units/$id/edit/'
      path: '/edit'
      fullPath: '/media-units/$id/edit/'
      preLoaderRoute: typeof MediaUnitsIdEditIndexRouteImport
      parentRoute: typeof MediaUnitsIdRoute
    }
    '/offers/$offerId/versions/$versionId': {
      id: '/offers/$offerId/versions/$versionId'
      path: '/versions/$versionId'
      fullPath: '/offers/$offerId/versions/$versionId'
      preLoaderRoute: typeof OffersOfferIdVersionsVersionIdRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/offers/$offerId/units/$unitId': {
      id: '/offers/$offerId/units/$unitId'
      path: '/units/$unitId'
      fullPath: '/offers/$offerId/units/$unitId'
      preLoaderRoute: typeof OffersOfferIdUnitsUnitIdRouteImport
      parentRoute: typeof OffersOfferIdRoute
    }
    '/public/offers/$token/units/$unitId': {
      id: '/public/offers/$token/units/$unitId'
      path: '/units/$unitId'
      fullPath: '/public/offers/$token/units/$unitId'
      preLoaderRoute: typeof PublicOffersTokenUnitsUnitIdRouteImport
      parentRoute: typeof PublicOffersTokenRoute
    }
  }
}

interface MediaUnitsIdRouteChildren {
  MediaUnitsIdIndexRoute: typeof MediaUnitsIdIndexRoute
  MediaUnitsIdEditIndexRoute: typeof MediaUnitsIdEditIndexRoute
}

const MediaUnitsIdRouteChildren: MediaUnitsIdRouteChildren = {
  MediaUnitsIdIndexRoute: MediaUnitsIdIndexRoute,
  MediaUnitsIdEditIndexRoute: MediaUnitsIdEditIndexRoute,
}

const MediaUnitsIdRouteWithChildren = MediaUnitsIdRoute._addFileChildren(
  MediaUnitsIdRouteChildren,
)

interface OffersOfferIdRouteChildren {
  OffersOfferIdClientRoute: typeof OffersOfferIdClientRoute
  OffersOfferIdIndexRoute: typeof OffersOfferIdIndexRoute
  OffersOfferIdUnitsUnitIdRoute: typeof OffersOfferIdUnitsUnitIdRoute
  OffersOfferIdVersionsVersionIdRoute: typeof OffersOfferIdVersionsVersionIdRoute
}

const OffersOfferIdRouteChildren: OffersOfferIdRouteChildren = {
  OffersOfferIdClientRoute: OffersOfferIdClientRoute,
  OffersOfferIdIndexRoute: OffersOfferIdIndexRoute,
  OffersOfferIdUnitsUnitIdRoute: OffersOfferIdUnitsUnitIdRoute,
  OffersOfferIdVersionsVersionIdRoute: OffersOfferIdVersionsVersionIdRoute,
}

const OffersOfferIdRouteWithChildren = OffersOfferIdRoute._addFileChildren(
  OffersOfferIdRouteChildren,
)

interface PublicOffersTokenRouteChildren {
  PublicOffersTokenIndexRoute: typeof PublicOffersTokenIndexRoute
  PublicOffersTokenUnitsUnitIdRoute: typeof PublicOffersTokenUnitsUnitIdRoute
}

const PublicOffersTokenRouteChildren: PublicOffersTokenRouteChildren = {
  PublicOffersTokenIndexRoute: PublicOffersTokenIndexRoute,
  PublicOffersTokenUnitsUnitIdRoute: PublicOffersTokenUnitsUnitIdRoute,
}

const PublicOffersTokenRouteWithChildren =
  PublicOffersTokenRoute._addFileChildren(PublicOffersTokenRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AvailabilityImportRoute: AvailabilityImportRoute,
  LoginRoute: LoginRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminPermissionsRoute: AdminPermissionsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminUsersRoute: AdminUsersRoute,
  MediaUnitsIdRoute: MediaUnitsIdRouteWithChildren,
  MediaImportRoute: MediaImportRoute,
  OffersOfferIdRoute: OffersOfferIdRouteWithChildren,
  OffersNewRoute: OffersNewRoute,
  AdminIndexRoute: AdminIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  MapIndexRoute: MapIndexRoute,
  MediaUnitsIndexRoute: MediaUnitsIndexRoute,
  OffersIndexRoute: OffersIndexRoute,
  ReservationsIndexRoute: ReservationsIndexRoute,
  SuppliersIndexRoute: SuppliersIndexRoute,
  AdminDictionariesFormatGroupsRoute: AdminDictionariesFormatGroupsRoute,
  AdminDictionariesFormatsRoute: AdminDictionariesFormatsRoute,
  AdminDictionariesTagsRoute: AdminDictionariesTagsRoute,
  PublicOffersTokenRoute: PublicOffersTokenRouteWithChildren,
  AdminPoisIndexRoute: AdminPoisIndexRoute,
  MediaUnitsAddIndexRoute: MediaUnitsAddIndexRoute,
  MediaUnitsTrashIndexRoute: MediaUnitsTrashIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
